import { motion } from "framer-motion";
import annotifyIcon from "../assets/annotify.png";
import { colors } from "../common/constants";

export const PaymentPlans = () => {
  const plans = [
    {
      name: "Free",
      price: "$0",
      description:
        "Basic plan with all essential features to add notes on any webpage.",
      features: ["Add unlimited notes", "Customize notes with colors"],
      highlight: false,
      hasAction: false,
    },
    {
      name: "Pro",
      price: "$5 / month",
      description:
        "Unlock sync across browsers and never lose your notes. Perfect for power users.",
      features: ["All Free features", "Sync notes across browsers"],
      highlight: true,
      hasAction: true,
    },
  ];

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 animate-gradient bg-[linear-gradient(-45deg,#81D8D0,#D7D982,#D99382,#245F73)] bg-[length:400%_400%]" />
      <div className="absolute inset-0 bg-club-base/80" />

      <div className="relative z-10 flex flex-col items-center">
        <motion.img
          src={annotifyIcon}
          alt="Annotify Icon"
          className="w-20 h-20 mx-auto drop-shadow-lg"
          animate={{ scale: [1, 1.1, 1] }}
          transition={{ repeat: Infinity, duration: 2 }}
        />
        <h1 className="text-5xl font-extrabold mt-4" style={{ color: colors.accent }}>
          Annotify
        </h1>
        <p className="mt-3 text-lg text-club-secondary text-center">
          Add <span style={{ color: colors.tealOption }}>fun notes</span> to any website 🎯
        </p>
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center p-8">
        {/* Header */}
        <motion.h1
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="text-4xl md:text-5xl font-extrabold mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-club-accent via-club-tealOption to-club-redOption animate-text-shimmer drop-shadow-lg"
        >
          Choose Your Plan
        </motion.h1>


        {/* Plans Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl w-full">
          {plans.map((plan, index) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2 }}
              className={`rounded-2xl shadow-lg p-6 md:p-8 flex flex-col justify-between border-2 transition-transform hover:scale-105 cursor-pointer ${plan.highlight
                  ? "border-club-accent bg-white"
                  : "border-club-secondary"
                }`}
            >
              <div>
                <h2 className="text-2xl font-semibold text-club-accent mb-2">
                  {plan.name}
                </h2>
                <p className="text-3xl font-bold text-gray-800 mb-4">
                  {plan.price}
                </p>
                <p className="text-gray-600 mb-6">{plan.description}</p>
                <ul className="space-y-3">
                  {plan.features.map((feature, i) => (
                    <li key={i} className="flex items-center gap-2">
                      <span className="w-2.5 h-2.5 bg-club-accent rounded-full"></span>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {plan.hasAction && <button
                className={`mt-8 w-full py-3 rounded-xl font-medium transition-colors ${plan.highlight
                    ? "bg-club-accent text-white hover:bg-club-accent/80"
                    : "bg-club-secondary text-black hover:bg-club-yellowOption"
                  }`}
              >
                {plan.highlight ? "Upgrade to Pro" : "Get Started"}
              </button>}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
